export default "__VITE_ASSET__xM3I2$pg__"